module.exports = __webpack_public_path__ + "img/placeholder.a36832a1.png";